module.exports = {
  // Url: "http://3.12.253.202:2901/api/user",
  // imageUrl: "https://ride-chef-dev.s3.ap-south-1.amazonaws.com/",

  Url: "https://api.praansconsultech.com:2901/api/user",
  imageUrl: "https://praans-bucket.s3.ap-south-1.amazonaws.com/",
};
